module.exports = __webpack_public_path__ + "assets/img/private.cc26dc75.png";